// extracted by mini-css-extract-plugin
var _1 = "NewsboardPost-moduleNewsboardPost__SQzxa";
var _2 = "NewsboardPost-modulefullWidth__GmwZF";
export { _1 as "NewsboardPost", _2 as "fullWidth" }
